import { render, staticRenderFns } from "./RecycleFeeForm.vue?vue&type=template&id=584e27b5&"
import script from "./RecycleFeeForm.vue?vue&type=script&lang=js&"
export * from "./RecycleFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports